import { recursiveBillingSetupConstants } from '../constants';

import { Toaster } from "components";

import { promiseInstance_authorization } from './config';

import { func_validation, func_serviceHandling } from 'functions';



export const recursiveBillingSetupActions = {
	setMaster,

	addAccount,
	addMultiAccount,
	deleteAccount,
	deactivateAccount,
	updateAccount,

	getExistingDealerCodeList,
	getExistingSalesPersonCodeList,
	updateDealerCode,
	updateSalesPersonCode,

	getAllBillingSetup,
	getBillingSetup,
	getUnbillBillingSetup,

	getNonautomatedAccountList,
	getAutomatedAccountList,
	removeAutomatedAccounts,
	addAutomatedAccounts,

	deleteAllBillingSetup,
	importMassBillingSetup,

	getRemarks,
	updateRemarks,

	getFullAgentCodeList,
	getFullProductDetailList,
	getFullProductDetail
}

function setMaster(accountNo) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/setMaster?accountNo=' + accountNo)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully set master"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to set master";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.setMaster_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.setMaster_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.setMaster_failure, error }; }
}

function addAccount(accountInfo) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/BillingSetup', JSON.stringify(accountInfo))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully added account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.addAccount_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.addAccount_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.addAccount_failure, error }; }
}

function addMultiAccount(accountInfoList) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/BillingSetup/MassInsertOrUpdate', JSON.stringify(accountInfoList))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully added multi account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add multi accounts";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.addMultiAccount_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.addMultiAccount_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.addMultiAccount_failure, error }; }
}

function deactivateAccount(billingSetupId) {
    return dispatch => {
		dispatch(request());

		let billingSetupId_formatted = "";
		if (func_validation.isNumberValid(billingSetupId)) billingSetupId_formatted = billingSetupId;

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/BillingSetup/Deactivate/' + billingSetupId_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deactivated account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to deactivated account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.deactivateAccount_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.deactivateAccount_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.deactivateAccount_failure, error }; }
}

function deleteAccount(billingSetupId) {
    return dispatch => {
		dispatch(request());

		let billingSetupId_formatted = "";
		if (func_validation.isNumberValid(billingSetupId)) billingSetupId_formatted = billingSetupId;

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/BillingSetup/' + billingSetupId_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deleted account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.deleteAccount_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.deleteAccount_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.deleteAccount_failure, error }; }
}

function updateAccount(accountInfo) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/BillingSetup', JSON.stringify(accountInfo))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully updated account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.updateAccount_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.updateAccount_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.updateAccount_failure, error }; }
}

function getExistingDealerCodeList() {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/BillingSetup/GetDealerCode')
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getExistingDealerCodeList_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getExistingDealerCodeList_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getExistingDealerCodeList_failure, error }; }
}

function getExistingSalesPersonCodeList() {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/BillingSetup/GetSalesPersonCode')
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getExistingSalesPersonCodeList_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getExistingSalesPersonCodeList_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getExistingSalesPersonCodeList_failure, error }; }
}

function updateDealerCode(oldCode, newCode) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			let paramObj = {
				oldDealerCode: oldCode, newDealerCode: newCode
			}

			let url = func_serviceHandling.createUrlWithParams('/BillingSetup/UpdateDealerCode', paramObj)
			
			axios.put(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully updated dealer code"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update dealer code";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.updateDealerCode_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.updateDealerCode_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.updateDealerCode_failure, error }; }
}

function updateSalesPersonCode(oldCode, newCode) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			let paramObj = {
				oldSalesPersonCode: oldCode, newSalesPersonCode: newCode
			}

			let url = func_serviceHandling.createUrlWithParams('/BillingSetup/UpdateSalesPersonCode', paramObj)
			
			axios.put(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully updated sales person code"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update sales person code";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.updateSalesPersonCode_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.updateSalesPersonCode_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.updateSalesPersonCode_failure, error }; }
}

function getAllBillingSetup(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let comId = func_validation.getObjectPropertyValue(filterOptions, "comId","");
		let accountCode = func_validation.getObjectPropertyValue(filterOptions, "accountCode","");
		let productCode = func_validation.getObjectPropertyValue(filterOptions, "productCode","");
		let isDraft = func_validation.getObjectPropertyValue(filterOptions, "isDraft", false);

		let paramObj = {
			offset: offset,
			limit: 0,
			sort: sort,
			comId: comId,
			accountCode: accountCode,
			productCode: productCode,
			isDraft: isDraft
		}

		let nextBilledDate = func_validation.getObjectPropertyValue(filterOptions, "nextBilledDate","");
		let path = (func_validation.isStringEqual_caseInsensitive(nextBilledDate, "Till Today"))? 
			"/BillingSetup/SearchUnbillBillingSetup"
			:"/BillingSetup/Search";

		let url = func_serviceHandling.createUrlWithParams(path, paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getAllBillingSetup_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getAllBillingSetup_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getAllBillingSetup_failure, error }; }
}

function getBillingSetup(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset,
			limit: pageSize,
			sort,
			// isIncludeDeletedDiscount: true,
			...filterOptions
		}

		let url = func_serviceHandling.createUrlWithParams('/BillingSetup/Search', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getBillingSetup_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getBillingSetup_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getBillingSetup_failure, error }; }
}

function getUnbillBillingSetup(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let comId = func_validation.getObjectPropertyValue(filterOptions, "comId","");
		let accountCode = func_validation.getObjectPropertyValue(filterOptions, "accountCode","");
		let productCode = func_validation.getObjectPropertyValue(filterOptions, "productCode","");

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			comId: comId,
			accountCode: accountCode,
			productCode: productCode,
		}

		let url = func_serviceHandling.createUrlWithParams('/BillingSetup/SearchUnbillBillingSetup', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getUnbillBillingSetup_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getUnbillBillingSetup_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getUnbillBillingSetup_failure, error }; }
}

function getNonautomatedAccountList() {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/BillingSetup/GetFilteredAccountCodeList')
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getNonautomatedAccountList_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getNonautomatedAccountList_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getNonautomatedAccountList_failure, error }; }
}

function getAutomatedAccountList() {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/BillingSetup/GetAutomateAccountList')
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getAutomatedAccountList_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getAutomatedAccountList_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getAutomatedAccountList_failure, error }; }
}

function removeAutomatedAccounts(accounts) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/BillingSetup/DeleteAutomateList', { data: JSON.stringify(accounts) })
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully removed automated account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to remove automated account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.removeAutomatedAccounts_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.removeAutomatedAccounts_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.removeAutomatedAccounts_failure, error }; }
}

function addAutomatedAccounts(accounts) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/BillingSetup/AddAutomateList', JSON.stringify(accounts))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully added automated account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add automated account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.addAutomatedAccounts_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.addAutomatedAccounts_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.addAutomatedAccounts_failure, error }; }
}

function deleteAllBillingSetup() {
    return dispatch => {
		dispatch(request());

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/BillingSetup/DeleteAll')
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete entire database before import";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.deleteAllBillingSetup_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.deleteAllBillingSetup_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.deleteAllBillingSetup_failure, error }; }
}

function importMassBillingSetup(files) {
    return dispatch => {
		dispatch(request());

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/BillingSetup/MassInsertOrUpdate', JSON.stringify(files))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully uploaded file"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to upload file";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.importMassBillingSetup_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.importMassBillingSetup_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.importMassBillingSetup_failure, error }; }
}

function getRemarks(accountCode) {
    return dispatch => {
		dispatch(request());

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/BillingSetup/GetCustomerNote?accountCode=' + accountCode)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to get remarks";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getRemarks_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getRemarks_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getRemarks_failure, error }; }
}

function updateRemarks(remarkObj) {
    return dispatch => {
		dispatch(request());

		let url = func_serviceHandling.createUrlWithParams('/BillingSetup/UpdateCustomerNote', remarkObj);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "error", msg: "Successfully updated remarks"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update remarks";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.updateRemarks_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.updateRemarks_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.updateRemarks_failure, error }; }
}

function getFullAgentCodeList() {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/BillingSetup/GetAgentCodeV2', {
				timeout: 30000
			})
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getFullAgentCodeList_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getFullAgentCodeList_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getFullAgentCodeList_failure, error }; }
}

function getFullProductDetailList() {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/BillingSetup/GetProductCodeNameV2', {
				timeout: 30000
			})
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getFullProductDetailList_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getFullProductDetailList_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getFullProductDetailList_failure, error }; }
}

function getFullProductDetail(productCode) {
    return dispatch => {
		dispatch(request());

		let url;
		if(func_validation.isNotNullUndefined(productCode))
			url = func_serviceHandling.createUrlWithParams('/BillingSetup/GetDefaultProducts', { productCode });
		else
			url = '/BillingSetup/GetDefaultProducts'

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url, {
				timeout: 30000
			})
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: recursiveBillingSetupConstants.getFullProductDetail_request, details }; }
    function success(details) { return { type: recursiveBillingSetupConstants.getFullProductDetail_success, details }; }
    function failure(error) { return { type: recursiveBillingSetupConstants.getFullProductDetail_failure, error }; }
}